import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import domAttr from 'dojo/dom-attr';
import domStyle from 'dojo/dom-style';
import domClass from 'dojo/dom-class';
import domConstructTyped from 'dojo/dom-construct';
import _Switchable from './_Switchable';
import template from './templates/Select.html?raw';
import on from 'dojo/on';
import _MandatoryMixin from '../../Controls/_MandatoryMixin/_MandatoryMixin';

const domConstruct: any = domConstructTyped;

class Select extends compose(_Switchable, _MandatoryMixin) {
    [key: string]: any;

    templateString: any = template;

    placeholder: any = null;
    value: any = null;
    label = "";
    options: any = [];
    menuItems: any = [];
    iconHeight: any = null;
    useIcons = false;
    iconColEmptyWidth = "60px";
    _data: any = [];

    //mandatoryNodeName: "DropdownContainer",


    _getLabelAttr() {
        return this.label;
    }

    _getEntityAttr() {
        for (var i = 0; i < this._data.length; i++) {
            var entity = this._data[i];

            if (entity.ID == this.get("value")) {
                return entity;
            }
        }

        return null;
    }

    onValueChange() {
        super.onValueChange.apply(this, arguments as any);

        //console.log("select valuechange", this.value);
        this.setSelectedOption(this.value);
        this.updatePlaceholderState();

        this._checkValidity();


    }

    _onChange_Select() {
        var value = this.mSelect.value;
        //console.log("_onChange_Select", value);
        this.set("value", value);

        this.emit("change")
    }

    _onClick_Item(value: any, evt: any) {
        //console.log("onClick_Item", evt, value);

        this.mSelect.value = value;
        this._onChange_Select();

        //evt.stopPropagation();
    }

    _onClick_Dropdown(evt: any) {

        this._toggleDropdown();

        //evt.stopPropagation();
    }

    _toggleDropdown(bShow?: any) {  // ferdinand liebt Toggles :)
        if (this.get("EditMode") != true) {
            return;
        }
        var state = domStyle.get(this.ItemContainer, "display");
        var targetState = "none";

        if (bShow === true) {
            targetState = "block";
        } else if (bShow === false) {
            targetState = "none";
        } else if (state == "block") {
            targetState = "none";
        } else {
            targetState = "block";
        }

        domStyle.set(this.ItemContainer, "display", targetState);

        // JS2TS: 'evt' is an undefined identifier in the original (the parameter is 'bShow'); preserved as (window as any).evt so the guarded branch behaves identically (typeof is "undefined" → never enters).
        if (typeof ((window as any).evt) != "undefined") {
            (window as any).evt.stopPropagation();
        }
    }

    EnabledChanged() {
        super.EnabledChanged.apply(this, arguments as any);
    }

    EditModeChanged() {
        super.EditModeChanged.apply(this, arguments as any);
        if (this.get("editMode") === true) {
            domStyle.set(this.mSelect, "display", "block");
            domStyle.set(this.mLabel, "display", "none");

            domStyle.set(this.LabelNode, "display", "none");
            domStyle.set(this.DropdownContainer, "display", "flex");
        } else {
            domStyle.set(this.mSelect, "display", "none");
            domStyle.set(this.mLabel, "display", "block");

            domStyle.set(this.LabelNode, "display", "block");
            domStyle.set(this.DropdownContainer, "display", "none");
        }
    }

    addOption(value: any, label: any, hoverTitle: any, base64ImgSource: any, entity: any) {
        //console.log("addOption", label);

        this.options.push(domConstruct.create("option", {
            value: value,
            innerHTML: label
        }, this.mSelect));

        var iconTag = "";
        if (typeof (base64ImgSource) != "undefined" && base64ImgSource != "" && base64ImgSource != null) {
            var imgHeightStyle = "";
            if (this.iconHeight != null ) {
                imgHeightStyle = "max-height: " + this.iconHeight + ";";
            }
            iconTag = "<img src=\"" + base64ImgSource + "\" style=\"" + imgHeightStyle + "margin-right: 4px; width: " + this.iconColEmptyWidth+"\" />";
        }

        if (this.useIcons == true && iconTag == "") {
            iconTag = "<span style=\"margin-right: "+this.iconColEmptyWidth+"\"></span>";
        }

        var callingTarget = lang.hitch(this, "_onClick_Item", value);

        // Menüeintrage fürs Dropdown
        var target = this.ItemContainer;
        var classNames = "mds-border-light-gray w3-block w3-padding mds-hover-dark"

        var li = domConstruct.create("div", {
            "className": classNames,
            "style": {
                borderBottom: "1px dotted gray"
            },
            "innerHTML": iconTag + label
        }, target);

        if(this.iconHeight != null) {
            domStyle.set(li, "minHeight", this.iconHeight);
        }


        if (hoverTitle != "" && typeof (hoverTitle) != "undefined") {
            domAttr.set(li, "title", hoverTitle);
        }

        on(li, "click", callingTarget);

        this.menuItems.push(li);

        if (typeof (hoverTitle) == "string") {
            domAttr.set(li, "title", hoverTitle);
            domAttr.set(this.options[this.options.length - 1], "title", hoverTitle);
        }

        // vorheriges Element muss border-bottom bekommen!
        var length = this.menuItems.length
        if (length > 1) {
            domClass.add(this.menuItems[length - 2], "mds-border-bottom");
        }

        if (entity) {
            this._data.push(entity);
        }
    }

    resetOptions() {
        domAttr.set(this.mSelect, "innerHTML", "");
        this.options = [];

        this.options.push(domConstruct.create("option", {
            className: "w3-hide",
            selected: "",
            disabled: "",
            value: -1,
            innerHTML: this.placeholder
        }, this.mSelect));



        domAttr.set(this.ItemContainer, "innerHTML", "");
        this.menuItems = [];

        var target = this.ItemContainer;
        var classNames = "mds-border-light-gray w3-block w3-padding w3-disabled w3-hide";

        var li = domConstruct.create("div", {
            "className": classNames,
            "disabled": "",
            "style": {
                //height: "100%"
            },
            "innerHTML": this.placeholder
        }, target);
        this.menuItems.push(li)
    }

    setSelectedOption(value: any) {
        this.value = value;
        var selectedIndex = -1;
        //console.log("setSelectedOption", this.value, this.options, this.menuItems, this.placeholder);
        for (var i = 0; i < this.options.length; i++) {
            if (this.options[i].value == this.value) {
                this.options[i].selected = true;
                this.label = this.options[i].innerHTML;
                domAttr.set(this.mLabel, "innerHTML", this.label);
                domAttr.set(this.LabelNode, "innerHTML", this.label);
                domAttr.set(this.dropdownLabel, "innerHTML", this.label);
                selectedIndex = i; // fürs Dropdown merken
            } else {
                this.options[i].selected = false;
            }
        }

        for (var i = 0; i < this.menuItems.length; i++) {
            var item = this.menuItems[i];
            if (i == selectedIndex) {
                domClass.add(item, "mds-orange");
                domClass.remove(item, "mds-hover-dark");
            } else {
                domClass.remove(item, "mds-orange");
                domClass.add(item, "mds-hover-dark");
            }
        }
    }

    updatePlaceholderState() {
        if (this.value == null) {
            if (this.placeholder != null) {
                domAttr.set(this.dropdownLabel, "innerHTML", this.placeholder);
                domStyle.set(this.dropdownLabel, "color", "gray");
            } else {
                domStyle.set(this.dropdownLabel, "color", "");
            }
        } else {
            domStyle.set(this.dropdownLabel, "color", "");
        }
    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);

        this._data = [];
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.updatePlaceholderState();
        this.resetOptions();
        //this.set("value", this.value);

        //on(window, "click", lang.hitch(this, function () {
        //    this._toggleDropdown(false);
        //}));
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    _setupSubscriptions(): void {
        super._setupSubscriptions.apply(this, arguments as any);
    }

    destroy(): void {
        super.destroy.apply(this, arguments as any);
    }
}
Select.prototype.declaredClass = 'more.Legacy.Zal.Switchable.Select';

export default mdsWidget(Select);
